import { forEach, pickBy } from 'lodash'

export default {
  methods: {
    addValidateErrors (observer, err) {
      if (!err.status || err.status !== 400 || !err.data || !err.data.errors) {
        return
      }

      forEach(err.data.errors, (item) => {
        pickBy(observer.errors, (value, key) => {
          if (item.field === key) {
            value.push(item.message)
          }
        })
      })
    },

    getValidateErrorMessage (err) {
      if (!err.status || err.status !== 400 || !err.data || !err.data.errors) {
        return ''
      }

      const status = err.status
      const msg = err.data.errors[0].message
      return `${msg}\ncode:${status}`
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/error.mixin.js